/*
  Wubs videosektion.

  film   Klick på knappen startar filmen och döljer överlägget. Filmen har preload="none",
         så 28 MB hämtas först när någon faktiskt vill se den.

  slinga Tyst loop av ett UTSNITT ur samma film – ingen separat klippning behövs. Vi spolar
         till startpunkten och tillbaka igen när fönstret tagit slut. Slingan startar först
         när sektionen syns, och pausas när den lämnar skärmen: en video som spelar utanför
         vyn drar data och batteri utan att någon ser den.
*/
(function () {
  var sektioner = [].slice.call(document.querySelectorAll('[data-wubs-video]'));
  if (!sektioner.length) return;

  sektioner.forEach(function (rot) {
    /* Flera format kan ligga i markupen – bara ETT syns (wubs-video.css). Spela det synliga,
       annars hade en dold stående film börjat ladda och spela på en desktop.
       ⚠️ offsetParent är null för allt som är display:none, vilket är precis det vi frågar efter. */
    function synligVideo() {
      var kallor = [].slice.call(rot.querySelectorAll('[data-vid-kalla] video'));
      if (!kallor.length) return rot.querySelector('video');  // null i YouTube-läget – hanteras nedan
      for (var i = 0; i < kallor.length; i++) {
        if (kallor[i].offsetParent !== null) return kallor[i];
      }
      return kallor[0];
    }
    var video = synligVideo();

    /* ---- YouTube-läget (Liam 2026-09-29: "vi ska använda youtube istället. Lättare för sidan") ----
       Markupen är en FASAD: en stillbild och ingenting mer. Iframen byggs här, först när filmen ska
       spelas. Det är hela poängen – en inbäddad spelare som ligger i sidan drar in YouTubes
       spelarskript vid varje sidladdning, oavsett om någon tittar.
       ⚠️ youtube-nocookie.com, inte youtube.com: ingen spårning förrän kunden själv startar. */
    var ytKallor = [].slice.call(rot.querySelectorAll('[data-yt]'));
    if (ytKallor.length) {
      var ytSlinga = rot.getAttribute('data-lage') !== 'film';

      function synligKalla() {
        for (var i = 0; i < ytKallor.length; i++) {
          if (ytKallor[i].offsetParent !== null) return ytKallor[i];
        }
        return ytKallor[0];
      }

      function ytUrl(kalla) {
        var id = kalla.getAttribute('data-yt');
        var start = parseInt(kalla.getAttribute('data-yt-start'), 10) || 0;
        var p = ['playsinline=1', 'rel=0', 'modestbranding=1'];
        if (start > 0) p.push('start=' + start);
        if (ytSlinga) {
          /* ⚠️ loop=1 kräver playlist=<samma id> – utan den spelar YouTube filmen EN gång och
             lämnar en svart ruta. Odokumenterat men välkänt beteende. */
          p.push('autoplay=1', 'mute=1', 'controls=0', 'loop=1', 'playlist=' + id);
        } else {
          p.push('autoplay=1');
        }
        return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?' + p.join('&');
      }

      function bygg(kalla) {
        if (!kalla || kalla.querySelector('iframe')) return;
        var ram = document.createElement('iframe');
        ram.className = 'wubs-vid__yt';
        ram.src = ytUrl(kalla);
        ram.title = rot.getAttribute('data-yt-titel') || 'Film';
        ram.setAttribute('frameborder', '0');
        ram.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share');
        ram.setAttribute('allowfullscreen', '');
        kalla.appendChild(ram);
      }

      /* Bara EN iframe lever åt gången. Utan rivningen hade en rotation lämnat den dolda filmen
         igång i bakgrunden – osynlig, men fullt spelande och fullt nedladdad. */
      function riv(utom) {
        ytKallor.forEach(function (k) {
          if (k === utom) return;
          var f = k.querySelector('iframe');
          if (f) f.parentNode.removeChild(f);
        });
      }

      if (ytSlinga) {
        var starta = function () {
          var k = synligKalla();
          riv(k);
          bygg(k);
        };
        var stoppa = function () { riv(null); rot.classList.remove('ar-igang'); };

        var reducerad = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducerad) return;   // stillbilden får stå kvar – ingen rörelse alls

        window.addEventListener('resize', function () { if (rot.classList.contains('ar-igang')) starta(); });
        window.addEventListener('orientationchange', function () { if (rot.classList.contains('ar-igang')) starta(); });

        if (!('IntersectionObserver' in window)) { rot.classList.add('ar-igang'); starta(); return; }
        new IntersectionObserver(function (poster) {
          poster.forEach(function (pp) {
            if (pp.isIntersecting) { rot.classList.add('ar-igang'); starta(); }
            else { stoppa(); }
          });
        }, { threshold: 0.25 }).observe(rot);
        return;
      }

      var ytKnapp = rot.querySelector('[data-vid-spela]');
      if (!ytKnapp) return;
      ytKnapp.addEventListener('click', function () {
        var k = synligKalla();
        rot.classList.add('ar-igang');
        riv(k);
        bygg(k);
      });
      return;
    }

    if (rot.getAttribute('data-lage') === 'film') {
      var knapp = rot.querySelector('[data-vid-spela]');
      if (!knapp) return;
      knapp.addEventListener('click', function () {
        // Hämtas VID KLICKET, inte vid start: skärmen kan ha roterat sedan sidan laddades.
        var v = synligVideo();
        if (!v) return;
        rot.classList.add('ar-igang');
        v.setAttribute('controls', 'controls');
        var spel = v.play();
        // play() kan avvisas (t.ex. strömsparläge) – då tar vi bort startläget igen
        // så knappen kommer tillbaka i stället för att bara försvinna.
        if (spel && spel.catch) spel.catch(function () { rot.classList.remove('ar-igang'); });
      });
      return;
    }

    if (!video) return;

    // ---- slinga ----
    var start = parseFloat(rot.getAttribute('data-start')) || 0;
    var langd = parseFloat(rot.getAttribute('data-langd')) || 14;
    var slut = start + langd;

    function tillStart(v) { try { v.currentTime = start; } catch (e) {} }

    /* Varje källa förbereds EN gång. Utan flaggan hade en rotation fram och tillbaka bundit
       timeupdate-lyssnaren flera gånger på samma element, och utsnittet börjat studsa. */
    function forbered(v) {
      if (v.getAttribute('data-vid-redo')) return v;
      v.setAttribute('data-vid-redo', '1');
      v.muted = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      v.addEventListener('loadedmetadata', function () { tillStart(v); });
      v.addEventListener('timeupdate', function () {
        if (v.currentTime >= slut || v.currentTime < start - 0.5) tillStart(v);
      });
      return v;
    }

    var aktiv = forbered(video);
    var reducerad = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducerad) {
      [].slice.call(rot.querySelectorAll('video')).forEach(function (v) { v.removeAttribute('autoplay'); });
      return;
    }

    var iVy = true;

    /* Skärmen kan byta brytpunkt mitt i sessionen (rotation, delad skärm, fönsterdrag). Då är den
       bundna källan plötsligt dold – den skulle fortsätta spela osynlig medan den nya stod still. */
    function bytKalla() {
      var ny = synligVideo();
      if (!ny || ny === aktiv) return;
      try { aktiv.pause(); } catch (e) {}
      aktiv = forbered(ny);
      if (iVy) aktiv.play().catch(function () {});
    }
    window.addEventListener('resize', bytKalla);
    window.addEventListener('orientationchange', bytKalla);

    if (!('IntersectionObserver' in window)) { aktiv.play().catch(function () {}); return; }
    new IntersectionObserver(function (poster) {
      poster.forEach(function (p) {
        iVy = p.isIntersecting;
        if (iVy) { bytKalla(); aktiv.play().catch(function () {}); }
        else { aktiv.pause(); }
      });
    }, { threshold: 0.25 }).observe(rot);
  });
})();
